import styled from '@emotion/styled';

import {mixinUnstyledButton} from '@ELib/styles/mixins';

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: var(--gutter);
  gap: var(--gutter-medium);
`;

export const GroupWrapper = styled.div`
  display: flex;
  gap: var(--gutter-small);
  flex-direction: column;
`;

export const TextButton = styled.button`
  ${mixinUnstyledButton}
  cursor: pointer;

  color: var(--color-core-link);
  font-size: var(--font-size-small);
  text-decoration: underline;
`;
